import type { Entity } from "@common/types/entity";
import { BreakableText } from "@design-system/BreakableText/BreakableText";
import { EntityAvatar } from "@components/avatar/EntityAvatar";
import { getEntityAvatarName } from "@helpers/entityAvatarName";
import styles from "./EntityDisplay.module.scss";

interface EntityDisplayProps {
    entity: Pick<Entity, "id" | "name" | "iconColor" | "logo" | "isPersonal">;
}

/**
 * An entity's avatar and one line of its name, which shows the full name in a
 * tooltip when truncated and copies the entity's ID on right-click.
 */
export const EntityDisplay = ({ entity }: Readonly<EntityDisplayProps>) => (
    <div className={styles.container}>
        <EntityAvatar entity={entity} size="xs" aria-hidden />
        <span className={styles.name}>
            <BreakableText
                text={getEntityAvatarName(entity)}
                copyId={entity.id}
                copyLabel="Entity"
                showTooltip
            />
        </span>
    </div>
);
